/**
 * User roles collection
 *
 * Contains a list of possible roles a user can have.
 *
 * @type {userRole[]} userRoles
 */
const userRoles = [
  {
    value: 'Technical Documentation and Parts',
    key: 'TechdocPartsReader',
    canBePublishedTo: false,
    canBeInvited: false,
    hasTeams: false,
    subscription: {
      message: false,
      alert: true,
    },
  },
  {
    value: 'Technical Documentation and Parts Admin',
    key: 'TechdocPartsAdmin',
    canBePublishedTo: false,
    canBeInvited: false,
    hasTeams: false,
    subscription: {
      message: false,
      alert: false,
    },
  },
  {
    value: 'Account In Shop',
    key: 'OrderInShop',
    canBePublishedTo: false,
    canBeInvited: false,
    hasTeams: false,
    subscription: {
      message: false,
      alert: false,
    },
  },
  {
    value: 'Instance Administrator',
    key: 'InstanceAdministrator',
    subscription: {
      message: true,
      alert: false,
    },
  },
  {
    value: 'PIN Creator',
    key: 'PinCreatorOnly_c',
    canBePublishedTo: false,
    canBeInvited: false,
    hasTeams: false,
    subscription: {
      message: false,
      alert: true,
    },
  },
]

export default userRoles
